import * as React from 'react';

import { Checkbox } from '@components';

import styles from '../Table.module.scss';
import { useTableContext } from '../TableContext';

type SelectAllCheckboxProps = {
  label?: string;
  selectAllOnePageAtATime?: boolean;
};

export function SelectAllCheckbox({ label, selectAllOnePageAtATime }: SelectAllCheckboxProps) {
  const { getTable, getRowId, selected, selectAll } = useTableContext();
  let checked;

  if (selectAllOnePageAtATime) {
    checked = getTable()
      ?.getRowModel()
      ?.rows.every((row) => selected.has(getRowId(row)));
  } else {
    checked = selected.size > 0 && getTable()?.getCoreRowModel()?.rows.length === selected.size;
  }

  return (
    <Checkbox
      label={label}
      provideValueOnChange
      onChange={selectAll}
      checked={checked}
      className={styles.selectAllCheckbox}
    />
  );
}
